import { AssetType, } from '@zattoo/playback-sdk';
export const PlayerWithReplay = (Base) => {
    return class extends Base {
        playProgram(cid, programId, playOptions) {
            return this.requestStream({
                playOptions,
                assetType: AssetType.REPLAY,
                watchRequestParams: {
                    cid,
                    program_id: programId,
                    dynamic_pvr: true,
                },
            });
        }
    };
};
